import React, { useState, useRef, useEffect } from "react";
import { Pencil } from "lucide-react";

const InlineEditableName = ({
  name,
  onRename,
  canEdit = true,
  className = "text-[#B2B5AD] text-[14px] font-semibold",
  tag: Tag = "span",
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(name);
  const inputRef = useRef(null);

  useEffect(() => {
    setEditValue(name);
  }, [name]);

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [isEditing]);

  const handleSubmit = () => {
    setIsEditing(false);
    const trimmed = editValue.trim();
    if (trimmed && trimmed !== name) {
      onRename?.(trimmed);
    } else {
      setEditValue(name);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit();
    } else if (e.key === "Escape") {
      setEditValue(name);
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <input
        ref={inputRef}
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        onBlur={handleSubmit}
        onKeyDown={handleKeyDown}
        style={{ width: `${Math.max(editValue.length, 1)}ch` }}
        className={`${className} bg-transparent outline-none`}
      />
    );
  }

  return (
    <span className="inline-flex items-center gap-1.5">
      <Tag
        className={`${className} ${canEdit ? "cursor-text hover:text-[#FEFCEB] transition-colors" : ""}`}
        onClick={() => canEdit && setIsEditing(true)}
      >
        {editValue}
      </Tag>
      {canEdit && (
        <button
          type="button"
          aria-label="Edit name"
          onClick={() => setIsEditing(true)}
          className="p-0.5 text-app-text-secondary hover:text-[#FEFCEB] transition-colors cursor-pointer"
        >
          <Pencil size={12} />
        </button>
      )}
    </span>
  );
};

export default InlineEditableName;
